/**
 * Detects Worldwide Treks context for logo / Feefo variant switching.
 * Uses route for /worldwide-treks/*, CMS page fields when setPage has run,
 * and site.children (available from the site plugin before the layout header
 * renders) so trek pages like /the-japanese-alps-mount-fuji get the WWT logo
 * during SSR — Header is a Suspense sibling of NuxtPage, so page.trekLocation
 * alone is often still empty on first paint.
 */
export function useIsWorldwideTreksPage() {
  const route = useRoute();
  const page = usePage();
  const site = useSite();

  return computed(() => {
    const path = route.path.replace(/\/$/, "") || "/";
    if (path === "/worldwide-treks" || path.startsWith("/worldwide-treks/")) {
      return true;
    }

    const current = page.value;
    if (
      current?.trekLocation === "Worldwide" ||
      current?.parentTrekLocation === "Worldwide" ||
      current?.title === "Worldwide Treks" ||
      current?.title === "Where Next?"
    ) {
      return true;
    }

    const pathWithoutSlash = path.replace(/^\//, "");
    const children = site.value?.children;
    if (!Array.isArray(children) || !pathWithoutSlash) {
      return false;
    }

    return children.some(
      (child: {
        uri?: string;
        id?: string;
        trekLocation?: string;
      }) => {
        if (child.trekLocation !== "Worldwide") return false;
        const uri = child.uri || child.id;
        if (!uri) return false;
        return pathWithoutSlash === uri || pathWithoutSlash.startsWith(`${uri}/`);
      },
    );
  });
}
